import basketsService from './basketsService'

export default basketsService



// WEBPACK FOOTER //
// ../src/services/basketsService/index.js